import styled from 'styled-components'

const DealCategoryWrapper = styled.div`
  .text-right { text-align: right; }
`

export default DealCategoryWrapper
